const styles = {
  paper: {
    padding: 30,
    textAlign: 'center'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/loaders/styles/ApplicationLoaderStyles.js